export default __webpack_public_path__ + "static/Paragraph_Left-a029af4fa1a32c011563456db1a52951.jpg";